<div class="flex gap-2" [ngClass]="{'justify-between': justify === 'justify-between', 'justify-end': justify === 'justify-end'}">
    <div class="border border-black rounded" [ngClass]="{'!opacity-50 !pointer-events-none': buttonOneDisabled}">
        <button
            mat-button
            (click)="handleButtonOneClick()"
            [disabled]="buttonOneDisabled"
        >
            {{buttonOneTitle}}
        </button>
    </div>
    <div class="border border-black !bg-black rounded" [ngClass]="{'!opacity-50 !pointer-events-none': buttonTwoDisabled}">
        <button
            mat-button
            (click)="handleButtonTwoClick()"
            class="!text-white"
            [disabled]="buttonTwoDisabled"
        >
            {{buttonTwoTitle}}
        </button>
    </div>
</div>
